import { FC, useCallback, useRef } from "react";
import { Toolbar, VerticalDivider } from "@remirror/react-ui";
import { RemirrorJSON } from "@remirror/core";
import { useHelpers } from "@remirror/react";
import { useLinkState } from "../../hooks/useLinkState";
import { LinkDialog } from "../LinkDialog";
import {
  BackgroundColorButtons,
  BackgroundColorProps,
  TextFormattingButtonGroup,
  HeadingLevelButtonGroup,
  FormattingButtonGroup,
  ListButtonGroup,
  LinkButton,
} from "./Buttons";
import "./WysiwygToolbar.css";

export const WysiwygToolbar: FC<
  BackgroundColorProps & {
    nodeId: string;
    onBlur: (json: RemirrorJSON) => void;
  }
> = ({ onBackgroundColorChange, backgroundColor, nodeId, onBlur }) => {
  const toolbarRef = useRef<HTMLDivElement>(null);
  const { isEditing } = useLinkState(nodeId);
  const { getJSON } = useHelpers();

  const onBlurWithJson = useCallback(() => {
    onBlur(getJSON());
  }, [getJSON, onBlur]);

  if (isEditing) {
    return (
      <div className="link-toolbar nodrag" ref={toolbarRef}>
        <Toolbar>
          <LinkDialog nodeId={nodeId} />
        </Toolbar>
      </div>
    );
  }

  return (
    <div className="wysiwyg-toolbar" ref={toolbarRef}>
      <Toolbar>
        <TextFormattingButtonGroup
          toolbarRef={toolbarRef}
          onBlur={onBlurWithJson}
        />
        <VerticalDivider onBlur={onBlurWithJson} />
        <HeadingLevelButtonGroup onBlur={onBlurWithJson} />
        <VerticalDivider />
        <FormattingButtonGroup onBlur={onBlurWithJson} />
        <VerticalDivider />
        <LinkButton nodeId={nodeId} />
        <VerticalDivider />
        <ListButtonGroup onBlur={onBlurWithJson} />
        <VerticalDivider />
        <BackgroundColorButtons
          backgroundColor={backgroundColor}
          onBackgroundColorChange={onBackgroundColorChange}
        />
      </Toolbar>
    </div>
  );
};
